import {
  useState,
  useEffect,
  useMemo,
  useCallback,
  Fragment,
  useContext,
} from "react";
import "./Scss/CaseStyles.scss?v=1.1.4";
import Swal from "sweetalert2";
import { NavLink } from "react-router-dom";

// MUI
import {
  Grid,
  TextField,
  Autocomplete,
  CircularProgress,
  Button,
  Fade,
  Collapse,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  ArrowForwardIos,
  CleaningServices,
  CreateNewFolder,
  Info,
  KeyboardArrowDown,
  KeyboardArrowUp,
  MoreVert,
  Search,
} from "@mui/icons-material";

// Componentes propios
import Table from "../Components/Common/Table/Table";
import LoadingPage from "../Components/Common/Loading/LoadingPage";
import {
  CommonSubHeader,
  getInfoMessageNoResultsSearch,
  formatDate,
  dateFormat,
  formatToTenDigits,
  normalizeText,
  formatDateWithoutHour,
} from "../Components/helpers/Helpers";

// Paginación
import ReactPaginate from "react-paginate";
import dayjs from "dayjs";
import { motion } from "framer-motion";
import {
  RenderCell,
  RenderStatus,
  RenderTrialDate,
  RenderVencimiento,
} from "../Components/Common/Table/RenderCell";
import api from "../api/axios";
import TableActions from "../Components/Common/Table/TableActions";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { PermissionContext } from "../Components/Context/Context";
import Unauthorized from "../Components/Common/Design/Unauthorized";
import { Box } from "@mui/system";
import { CustomButtonPlusIcon } from "../Components/Common/Design/CustomButtonPlusIcon";
import {
  buildCasesTableCacheKey,
  getCasesCacheVersion,
  readCasesTableCache,
  setCasesCacheVersion,
  writeCasesTableCache,
} from "./cache/casesCache";

// ---------- COMPONENTE PRINCIPAL ----------
const Expedientes = ({
  flagToShow = true,
  userCase = 0,
  clientCase = 0,
  handleCasesTransfer = () => {},
  setCaseControlNumber,
  transferClient,
  caseCreated,
  clientCreated,
  currentClientTransfer,
}) => {
  const { can } = useContext(PermissionContext);
  const hasPermission = can("cases", "view");

  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);

  const handleSort = (column, direction) => {
    console.log(column, direction);
    setSortColumn(column);
    setSortDirection(direction);
    setPagination((prev) => ({ ...prev, pagePressed: 1 }));
  };

  // ---------- ESTADOS ----------
  const [data, setData] = useState({
    cases: [],
    totalPagesNumber: 0,
    pageCount: 0,
  });
  const [queryCase, setQueryCase] = useState("");
  const [queryClientName, setQueryClientName] = useState("");
  const [queryClientSurname, setQueryClientSurname] = useState("");

  const initialFilters = {
    caseFilter: "",
    clientFilterName: "",
    clientFilterSurname: "",
    nombre_completo_status_task: "",
    case_type: null,
    association: null,
    lawyer: null,
    inactiveLawyer: null,
    peritaje: null,
    provincia: null,
    status: null,
    status_key: null,
    status_name: "",
    company_id: null,
  };

  const [filters, setFilters] = useState(initialFilters);

  const [pagination, setPagination] = useState({
    objPerPage: 10,
    pagePressed: 1,
  });
  const [flag, setFlag] = useState(false);
  const [dataNoResults, setDataNoResults] = useState(false);
  const [loading, setLoading] = useState({
    cases: false,
    types: false,
    provinces: false,
    case_status: false,
    associations: false,
    companies: false,
    peritaje: false,
    apud_acta: false,
    expiration: false,
    lawyers: false,
    inactiveLawyers: false,
  });
  const [options, setOptions] = useState({
    cases: [],
    types: [],
    provinces: [],
    case_status: [],
    associations: [],
    companies: [],
    peritaje: [],
    apud_acta: [],
    expiration: [],
    lawyers: [],
    inactiveLawyers: [],
  });
  const [search, setSearch] = useState(false);
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [dateEndFromTrial, setDateEndFromTrial] = useState(null);
  const [dateEndToTrial, setDateEndToTrial] = useState(null);
  const [dateEndFromUpdatedAt, setDateEndFromUpdatedAt] = useState(null);
  const [dateEndToUpdatedAt, setDateEndToUpdatedAt] = useState(null);

  const [
    dateDateRangeFromFinalTaskExpiration,
    setDateDateRangeFromFinalTaskExpiration,
  ] = useState(null);
  const [
    dateDateRangeToFinalTaskExpiration,
    setDateDateRangeToFinalTaskExpiration,
  ] = useState(null);

  const [dateTask, setDateTask] = useState(null);
  const [dateIn, setDateIn] = useState(null);
  const [dateUpdate, setDateUpdate] = useState(null);

  const [showFilters, setShowFilters] = useState(true);

  const smoothLayoutTransition = {
    layout: {
      type: "spring",
      stiffness: 185,
      damping: 30,
      mass: 0.85,
    },
  };

  const FILTER_INPUT_TEXT_SIZE = 12;
  const FILTER_INPUT_LEFT_PADDING = 10;
  const FILTER_INPUT_INNER_PADDING = 10;
  const FILTER_INPUT_TEXT_STYLE = {
    fontSize: `${FILTER_INPUT_TEXT_SIZE}px`,
    lineHeight: 1.4,
  };

  const FILTER_INPUT_SX = {
    ...FILTER_INPUT_TEXT_STYLE,
    "& .MuiInputLabel-root": {
      fontSize: `${FILTER_INPUT_TEXT_SIZE}px`,
      color: "#4b6079",
      transform: "translate(10px, 8px) scale(1)",
      transformOrigin: "top left",
      lineHeight: 1,
    },
    "& .MuiInputLabel-shrink": {
      transform: "translate(10px, -7px) scale(0.75)",
      backgroundColor: "#ffffff",
      padding: "0 4px",
      borderRadius: "4px",
      fontSize: `${FILTER_INPUT_TEXT_SIZE}px`,
    },
    "& .MuiInputBase-root": {
      height: "34px !important",
      borderRadius: "8px",
      backgroundColor: "#ffffff",
      transition:
        "box-shadow 220ms ease, border-color 220ms ease, background-color 220ms ease, transform 220ms ease",
      ...FILTER_INPUT_TEXT_STYLE,
    },
    "& .MuiInputBase-input": {
      padding: `0 ${FILTER_INPUT_INNER_PADDING}px`,
      color: "#1c2f47",
      ...FILTER_INPUT_TEXT_STYLE,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(28, 48, 74, 0.17)",
    },
    "& .MuiOutlinedInput-root": {
      "& legend": {
        fontSize: `${FILTER_INPUT_TEXT_SIZE}px`,
      },
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(23, 52, 90, 0.36)",
    },
    "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(23, 52, 90, 0.66)",
      borderWidth: "1px",
    },
    "& .Mui-focused": {
      boxShadow: "0 0 0 2px rgba(23, 52, 90, 0.12)",
    },
    "& .MuiAutocomplete-input": {
      ...FILTER_INPUT_TEXT_STYLE,
    },
    "& .MuiAutocomplete-endAdornment": {
      "& .MuiSvgIcon-root": {
        fontSize: `${FILTER_INPUT_TEXT_SIZE}px`,
      },
    },
    "& .MuiMenuItem-root": {
      fontSize: `${FILTER_INPUT_TEXT_SIZE}px`,
    },
    "& .MuiList-root": {
      "& .MuiMenuItem-root": {
        fontSize: `${FILTER_INPUT_TEXT_SIZE}px`,
      },
    },
  };

  // NUEVOS RANGOS
  const [dateTaskFrom, setDateTaskFrom] = useState(null);
  const [dateTaskTo, setDateTaskTo] = useState(null);
  const [caseFlagFromClient, setCaseFlagFromClient] = useState(false);

  // ---------- UTILIDADES ----------

  const renderCellWithDefault = (
    value,
    defaultValue = "Sin asignar",
    link = false,
    dateFlag,
  ) => (
    <div className="spanClassForTables centerContent">
      {link ? (
        <NavLink to={`/expedientes/ver?id=${value}`} className="buttonNavLink">
          <Button
            color="info"
            size="small"
            sx={{ fontSize: "12px", height: "28px" }}
            variant="outlined"
          >
            {value}
          </Button>
        </NavLink>
      ) : dateFlag ? (
        dateFormat(value)
      ) : (
        value || defaultValue
      )}
    </div>
  );

  const applyCasesResponsePayload = useCallback(
    (payload) => {
      if (!payload?.cases) return;

      const {
        cases,
        companyList,
        lawyersListNames,
        inactiveLawyers,
        provinceList,
        associationList,
        typesList,
        casesByStatusList,
      } = payload || {};

      if (userCase || clientCase) {
        setCaseControlNumber(cases?.total);
        setCaseFlagFromClient(true);
      }

      setDataNoResults(cases?.data?.length === 0);

      const peritajeList = [
        { id: -1, peritaje: "Seleccionar" },
        { id: 0, peritaje: "Sin Peritaje" },
        { id: 1, peritaje: "Con Peritaje" },
      ];

      const apudActaList = [
        { id: -1, apud_acta: "Seleccionar" },
        { id: 0, apud_acta: "Sin Apud acta" },
        { id: 1, apud_acta: "Con Apud acta" },
      ];

      const expirationList = [
        { id: -1, expiration: "Seleccionar" },
        { id: 0, expiration: "Sin Vencimiento" },
        { id: 1, expiration: "Con Vencimiento" },
      ];

      cases?.data?.map((item) => {
        const isJuicio =
          normalizeText(item?.cases_flow_relation?.status_name) === "juicio";

        if (item?.trial_date) {
          item.trial_date_time = {
            date_end: item.trial_date,
            source: "trial_date",
          };
        } else if (isJuicio && item?.last_task?.date_end) {
          item.trial_date_time = {
            ...item.last_task,
            source: "task_date",
          };
        }
      });

      setData({
        cases: cases?.data || [],
        totalPagesNumber: cases?.total || 0,
        pageCount: cases?.last_page || 0,
      });

      const uniqueCases = [
        {
          id: "status-select",
          nombre_completo_status_task: "Seleccionar",
          status_name: "",
          status: 0,
          status_key: "0",
        },
        ...Object.values(
          (casesByStatusList || [])
            .map((item) => ({
              ...item,
              id:
                Number(item?.status) === 3 || Number(item?.status) === 5
                  ? `status-${(item?.status_name || "").trim()}-won`
                  : `status-${(item?.status_name || "").trim()}-${Number(item?.status)}`,
              status_name: item.status_name?.trim(),
              status:
                Number(item?.status) === 3 || Number(item?.status) === 5
                  ? [3, 5]
                  : Number(item?.status),
              status_key:
                Number(item?.status) === 3 || Number(item?.status) === 5
                  ? "won"
                  : String(Number(item?.status)),
              nombre_completo_status_task:
                item.nombre_completo_status_task?.trim(),
            }))
            .reduce((acc, curr) => {
              const key = `${curr.status_name}-${curr.status_key}`;
              acc[key] = curr;
              return acc;
            }, {}),
        ),
      ];

      setOptions({
        associations: [
          { asoc_name: "Seleccionar", id: 0 },
          ...(associationList || []),
        ],
        lawyers: [
          { name: "Seleccionar", surname: " ", id: 0 },
          ...(lawyersListNames || []),
        ],
        inactiveLawyers: [
          { name: "Seleccionar", surname: " ", id: 0 },
          ...(inactiveLawyers || []),
        ],
        provinces: [
          { provincia: "Seleccionar", id_provincia: 0 },
          ...(provinceList || []),
        ],
        types: [{ case_type: "Seleccionar", id: 0 }, ...(typesList || [])],
        case_status: [...uniqueCases],
        companies: [
          { company_name: "Seleccionar", id: 0 },
          ...(companyList || []),
        ],
        peritaje: peritajeList,
        apud_acta: apudActaList,
        expiration: expirationList,
      });
    },
    [clientCase, setCaseControlNumber, userCase],
  );

  // ---------- FETCH DE DATOS ----------
  const getDataExpedientes = async () => {
    setFlag(true);

    console.log(sortColumn, sortDirection);

    let status_name = "";
    if (dateEndFromTrial || dateEndToTrial) {
      status_name = "Juicio";
    }

    const selectedLawyerId = filters?.lawyer ?? filters?.inactiveLawyer ?? null;
    const activeUserCaseId = Number(userCase) || null;
    const hasManualLawyerFilter =
      filters?.lawyer != null || filters?.inactiveLawyer != null;

    const requestPayload = {
      sortColumn,
      sortDirection,
      page: pagination?.pagePressed,
      objPerPage: pagination?.objPerPage,
      case_id: filters?.caseFilter,
      company_id: filters?.company_id ? filters?.company_id : null,
      case_type: filters?.case_type,
      asociation: filters?.association,
      province_name: filters?.provincia,
      association: filters?.association,
      status_task: filters?.status,
      status_name: status_name ? status_name : filters?.status_name,
      peritaje: filters?.peritaje,
      apud_acta: filters?.apud_acta,
      expiration: filters?.expiration,
      client_id: clientCase?.id || null,
      client_name: currentClientTransfer?.name || filters?.clientFilterName,
      client_surname:
        currentClientTransfer?.surname || filters?.clientFilterSurname,
      user_id: hasManualLawyerFilter
        ? selectedLawyerId
        : (activeUserCaseId ?? selectedLawyerId ?? null),
      date_from: dateFrom ? formatDateWithoutHour(dateFrom, "desde") : "",
      date_to: dateTo ? formatDateWithoutHour(dateTo, "hasta") : "",
      date_from_trial_range: dateEndFromTrial
        ? formatDateWithoutHour(dateEndFromTrial, "desde")
        : "",
      date_to_trial_range: dateEndToTrial
        ? formatDateWithoutHour(dateEndToTrial, "hasta")
        : "",
      date_from_updated_at_range: dateEndFromUpdatedAt
        ? formatDateWithoutHour(dateEndFromUpdatedAt, "desde")
        : "",
      date_to_updated_at_range: dateEndToUpdatedAt
        ? formatDateWithoutHour(dateEndToUpdatedAt, "hasta")
        : "",
      date_from_expired_at_range: dateDateRangeFromFinalTaskExpiration
        ? formatDateWithoutHour(dateDateRangeFromFinalTaskExpiration, "desde")
        : "",
      date_to_expired_at_range: dateDateRangeToFinalTaskExpiration
        ? formatDateWithoutHour(dateDateRangeToFinalTaskExpiration, "hasta")
        : "",
      date_in: dateIn ? formatDateWithoutHour(dateIn, "normal") : "",
      date_update: dateUpdate
        ? formatDateWithoutHour(dateUpdate, "normal")
        : "",
      date_task: dateTask ? formatDateWithoutHour(dateTask, "desde") : "",
      date_task_from: dateTaskFrom
        ? formatDateWithoutHour(dateTaskFrom, "desde")
        : "",
      date_task_to: dateTaskTo
        ? formatDateWithoutHour(dateTaskTo, "hasta")
        : "",
    };

    const currentCacheVersion = getCasesCacheVersion();
    const readCacheKey = buildCasesTableCacheKey(
      requestPayload,
      currentCacheVersion,
    );
    const cachedPayload = readCasesTableCache(readCacheKey);

    if (cachedPayload?.cases) {
      applyCasesResponsePayload(cachedPayload);
      setFlag(false);
    }

    try {
      if (pagination?.objPerPage >= 500) {
        Swal.fire({
          icon: "warning",
          title: "Carga de registros extensa",
          text: "Ha seleccionado un volumen elevado de registros. El proceso de carga puede tardar algunos segundos, le agradecemos su paciencia mientras se completan los archivos.",
          confirmButtonText: "Aceptar",
        });
      }

      const response = await api.post(
        process.env.REACT_APP_API_URL + `/cases`,
        requestPayload,
      );

      console.log(response, "response");

      applyCasesResponsePayload(response?.data);

      const backendCacheVersion = Number(
        response?.data?.cache_version || currentCacheVersion,
      );

      if (backendCacheVersion > 0) {
        setCasesCacheVersion(backendCacheVersion);
      }

      const writeCacheKey = buildCasesTableCacheKey(
        requestPayload,
        backendCacheVersion > 0 ? backendCacheVersion : currentCacheVersion,
      );
      writeCasesTableCache(writeCacheKey, response?.data);

      setFlag(false);
    } catch (error) {
      console.error("ERROR AXIOS:", error);

      if (error.response) {
        console.error("STATUS:", error.response.status);
        console.error("DATA:", error.response.data);
        console.error("HEADERS:", error.response.headers);
      } else if (error.request) {
        console.error("NO RESPONSE:", error.request);
      } else {
        console.error("REQUEST ERROR:", error.message);
      }
    } finally {
      setFlag(false);
      setLoading((prev) => ({ ...prev, companies: false }));
    }
  };

  // ---- Añadir después de los useState principales ----
  const filterDataByCompany = useCallback(
    async (company_id, flagFromCompanyInput = false) => {
      if (!company_id) return;

      setLoading((prev) => ({
        ...prev,
        associations: true,
        types: true,
        lawyers: true,
        inactiveLawyers: true,
      }));

      try {
        const response = await api.post(
          `${process.env.REACT_APP_API_URL}/users/searchdatabycompany`,
          { company: company_id },
        );

        if (response?.data) {
          const { cases_types, associations, lawyers } = response.data;

          // Actualizamos los valores dependientes
          setOptions((prevData) => ({
            ...prevData,
            associations: [
              { asoc_name: "Seleccionar", id: 0 },
              ...(associations || []),
            ],
            types: [
              { case_type: "Seleccionar", id: null },
              ...(cases_types || []),
            ],
            lawyers: [
              { name: "Seleccionar", surname: " ", id: 0 },
              ...(lawyers || []),
            ],
          }));

          // Si proviene del cambio directo en el input de empresa, reiniciamos los filtros dependientes
          if (flagFromCompanyInput) {
            setFilters((prev) => ({
              ...prev,
              association: null,
              case_type: null,
              lawyer: null,
              inactiveLawyer: null,
            }));
          }
        }
      } catch (error) {
        console.error("Error al filtrar por empresa:", error);
      } finally {
        setLoading((prev) => ({
          ...prev,
          associations: false,
          types: false,
          lawyers: false,
          inactiveLawyers: false,
        }));
      }
    },
    [],
  );

  const renderActions = (case_id, relation = false, row = false) => (
    <div
      className="spanClassForTables centerContent"
      style={{
        display: "flex",
        gap: "8px",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {!transferClient ? (
        <TableActions
          rute={"expedientes"}
          value={case_id}
          showView
          module="cases"
        />
      ) : null}

      {transferClient ? (
        <Button
          size="small"
          sx={{ fontSize: "12px", height: "28px" }}
          variant="outlined"
          color="secondary"
          onClick={() => handleCasesTransfer(row)}
        >
          Transferir
        </Button>
      ) : null}
    </div>
  );

  const handleFilterStates = () => {
    setFilters(initialFilters);
    setSortColumn(null);
    setSortDirection(null);
    setDateEndFromTrial(null);
    setDateEndToTrial(null);
    setDateEndFromUpdatedAt(null);
    setDateEndToUpdatedAt(null);
    setDateDateRangeFromFinalTaskExpiration(null);
    setDateDateRangeToFinalTaskExpiration(null);
    setDateFrom(null);
    setDateTo(null);
    setDateTaskFrom(null);
    setDateTaskTo(null);
    setDateIn(null);
    setDateUpdate(null);
    setDateTask(null);
    setQueryCase(""); // limpia el TextField
    setQueryClientName(""); // limpia el TextField
    setQueryClientSurname(""); // limpia el TextField
    setPagination({ objPerPage: 10, pagePressed: 1 }); // reinicia paginación
    setSearch(!search); // refresca la tabla
  };

  const handlePageClick = (event) => {
    setPagination((prev) => ({ ...prev, pagePressed: event.selected + 1 }));
  };

  const handleAutocompleteOpen = useCallback(() => {
    // No forzamos el estado de loading al abrir el popup. El spinner solo
    // debe activarse cuando realmente se está fetching datos async.
  }, []);

  const getOptionKey = useCallback((option, fallback = "option") => {
    if (option == null) {
      return fallback;
    }

    if (typeof option === "string" || typeof option === "number") {
      return `${fallback}-${String(option)}`;
    }

    const primaryValue =
      option.id ??
      option.value ??
      option.status_key ??
      option.status ??
      option.asoc_name ??
      option.company_name ??
      option.case_type ??
      option.provincia ??
      option.name ??
      option.label ??
      option.peritaje ??
      option.apud_acta ??
      option.expiration ??
      option.nombre_completo_status_task ??
      fallback;

    const secondaryValue =
      option.status_key ??
      option.id_provincia ??
      option.company_id ??
      option.status ??
      option.case_id ??
      option.value ??
      "";

    return `${String(primaryValue)}-${String(secondaryValue)}`;
  }, []);

  // ---------- COLUMNAS DE LA TABLA ----------
  const columns = useMemo(() => {
    const commonColumns = [
      {
        Header: `LISTA DE EXPEDIENTES`,
        columns: [
          {
            Header: "Expediente",
            accessor: "id",
            minWidth: 60,
            Cell: ({ value }) => (
              <RenderCell
                value={"#" + formatToTenDigits(value)}
                defaultValue=""
                link={true}
                dateFlag={false}
                icon={ArrowForwardIos}
                id={value}
                view="expedientes"
                color="success"
                iconPosition="end"
              />
            ),
          },
          {
            Header: "Cliente",
            sortField: "name",
            accessor: "full_client_name",
            minWidth: 150,

            Cell: ({ value }) => (
              <RenderCell value={value} view="expedientes" />
            ),
          },
          {
            Header: "Tipo de proceso",
            sortField: "case_type",
            accessor: "case_type_name",
            minWidth: 200,
            Cell: ({ value }) => (
              <RenderCell value={value} view="expedientes" />
            ),
          },
          {
            Header: "Abogado",
            sortField: "lawyer",
            accessor: "full_lawyer_name",
            minWidth: 150,
            Cell: ({ value }) => (
              <RenderCell value={value} view="expedientes" />
            ),
          },
          {
            Header: "Estado",
            sortField: "case_status",
            accessor: "full_case_status_name",
            minWidth: 150,
            Cell: ({ value }) => (
              <RenderStatus value={value} view="expedientes" />
              // <RenderCell value={value} view="expedientes" />
            ),
          },
          {
            Header: "Vencimientos",
            sortField: "expiration",
            accessor: "expiration",
            minWidth: 140,
            Cell: ({ value }) => (
              <RenderCell
                value={value ? "SI" : value == 0 ? "NO" : "Sin asignar"}
                view="expedientes"
              />
            ),
          },
          {
            Header: "Fecha entrada",
            sortField: "date_in",
            accessor: "date_in",
            minWidth: 170,
            Cell: ({ value }) => (
              <RenderCell value={value} dateFlag={true} view="expedientes" />
            ),
          },
          {
            Header: "Plazo de fin de tarea (automático)",
            sortField: "task_date_end",
            accessor: "last_task.date_end",
            minWidth: 200,
            Cell: ({ row }) => <RenderVencimiento {...row?.original} />,
          },
          {
            Header: "Provincia",
            sortField: "province",
            accessor: "case_province",
            minWidth: 150,
            Cell: ({ value }) => (
              <RenderCell value={value} view="expedientes" />
            ),
          },
          {
            Header: "Fecha de juicio",
            sortField: "trial_date",
            accessor: "trial_date_time",
            minWidth: 170,
            Cell: ({ value }) => (
              <RenderTrialDate dates={value} flagTrial={true} />
            ),
          },
          {
            Header: "Apud acta",
            accessor: "apud_acta",
            sortField: "apud_acta",
            minWidth: 100,
            Cell: ({ value }) => (
              <RenderCell
                value={value ? "SI" : value == 0 ? "NO" : "Sin asignar"}
                view="expedientes"
              />
            ),
          },
          {
            Header: "Peritaje",
            sortField: "peritaje",
            accessor: "peritaje",
            minWidth: 100,
            Cell: ({ value }) => (
              <RenderCell
                value={value ? "SI" : value == 0 ? "NO" : "Sin asignar"}
                view="expedientes"
              />
            ),
          },
          {
            Header: "Actualizado",
            sortField: "last_update",
            accessor: "last_update",
            minWidth: 140,
            Cell: ({ value }) => (
              <RenderCell value={value} dateFlag={true} view="expedientes" />
            ),
          },

          {
            Header: "Acciones",
            accessor: "case_id",
            Cell: ({ row }) =>
              renderActions(
                row?.original.case_id,
                row?.original.clients_relation,
                row?.original,
              ),
          },
        ],
      },
    ];

    if (flagToShow) {
      commonColumns[0].columns.splice(12, 0, {
        sortField: "asociation",
        Header: "Asociación",
        accessor: "case_asociation_name",
        minWidth: 190,
        Cell: ({ value }) => renderCellWithDefault(value),
      });
      commonColumns[0].columns.splice(12, 0, {
        sortField: "company_id",
        Header: "Empresa",
        minWidth: 100,
        accessor: "company_name",
        Cell: ({ value }) => renderCellWithDefault(value),
      });
    }

    return commonColumns;
  }, [flagToShow]);

  // ---------- HOOKS ----------

  useEffect(() => {
    if (!hasPermission) {
      return;
    }

    getDataExpedientes();
  }, [
    pagination,
    search,
    clientCase,
    userCase,
    transferClient,
    caseCreated,
    clientCreated,
    currentClientTransfer,
    hasPermission,
    sortColumn,
    sortDirection,
  ]);

  useEffect(() => {
    if (data?.pageCount && pagination?.pagePressed > data?.pageCount) {
      // Solo actualiza si el valor va a cambiar realmente
      if (pagination?.pagePressed !== 1) {
        setPagination((prev) => ({ ...prev, pagePressed: 1 }));
      }
    }
  }, [data?.pageCount]);

  useEffect(() => {
    setFilters((prevFilters) => ({ ...prevFilters, caseFilter: queryCase }));
  }, [queryCase]);

  useEffect(() => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      clientFilterName: queryClientName,
    }));
  }, [queryClientName]);

  useEffect(() => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      clientFilterSurname: queryClientSurname,
    }));
  }, [queryClientSurname]);

  const filterFields = [
    // ---------- TEXT & COMPANY ----------
    {
      type: "text",
      xs: 6,
      md: 1.5,
      label: "Nº  Expediente",
      value: queryCase,
      onChange: (e) => setQueryCase(e.target.value),
    },
    {
      type: "text",
      xs: 6,
      md: 1.5,
      label: "Nombre cliente",
      value: queryClientName,
      onChange: (e) => setQueryClientName(e.target.value),
    },
    {
      type: "text",
      xs: 12,
      md: 1.5,
      label: "Apellido Cliente",
      value: queryClientSurname,
      onChange: (e) => setQueryClientSurname(e.target.value),
    },

    // ---------- EMPRESA ----------
    {
      type: "autocomplete",
      xs: 6,
      md: 1.5,
      label: "Empresa",
      options: options.companies,
      loading: loading.companies,
      getOptionLabel: (option) => option?.company_name || "",
      getValue: (filters, options) =>
        (options || []).find((opt) => opt?.id === filters?.company_id) || null,
      setFilter: (value) => {
        const companyId = value?.id || null;
        setFilters((prev) => ({
          ...prev,
          company_id: companyId,
          association: null,
          case_type: null,
          lawyer: null,
        }));
        if (companyId) {
          filterDataByCompany(companyId, true);
        }
      },
      handleOpen: undefined,
      handleClose: undefined,
    },

    // ---------- ASOCIACION ----------
    {
      type: "autocomplete",
      xs: 6,
      md: 1.5,
      label: "Asociación",
      options: options.associations,
      loading: loading.associations,
      disabled: !filters?.company_id || loading.associations,
      getOptionLabel: (option) => option?.asoc_name || "",
      getValue: (filters, options) =>
        (options || []).find((opt) => opt?.id === filters?.association) || null,
      setFilter: (value) =>
        setFilters((prev) => ({ ...prev, association: value?.id || null })),
      handleOpen: undefined,
      handleClose: undefined,
    },

    // ---------- ABOGADO ----------
    {
      type: "autocomplete",
      xs: 6,
      md: 1.5,
      label: "Abogado",
      options: options.lawyers,
      loading: loading.lawyers,
      disabled: !filters?.company_id || loading.lawyers,
      getOptionLabel: (option) =>
        `${option?.name || ""} ${option?.surname || ""}`,
      getValue: (filters, options) =>
        (options || []).find((opt) => opt?.id === filters?.lawyer) || null,
      setFilter: (value) =>
        setFilters((prev) => ({
          ...prev,
          lawyer: value?.id || null,
          inactiveLawyer: value?.id ? null : prev.inactiveLawyer,
        })),
      handleOpen: undefined,
      handleClose: undefined,
    },
    // ---------- ABOGADO INACTIVO ----------
    {
      type: "autocomplete",
      xs: 6,
      md: 1.5,
      label: "Abogado Inactivo",
      options: options.inactiveLawyers,
      loading: loading.inactiveLawyers,
      disabled: !filters?.company_id || loading.inactiveLawyers,
      getOptionLabel: (option) =>
        `${option?.name || ""} ${option?.surname || ""}`,
      getValue: (filters, options) =>
        (options || []).find((opt) => opt?.id === filters?.inactiveLawyer) ||
        null,
      setFilter: (value) =>
        setFilters((prev) => ({
          ...prev,
          inactiveLawyer: value?.id || null,
          lawyer: value?.id ? null : prev.lawyer,
        })),
      handleOpen: undefined,
      handleClose: undefined,
    },

    // ---------- TIPO PROCESO ----------
    {
      type: "autocomplete",
      xs: 6,
      md: 1.5,
      label: "Tipo de proceso",
      options: options.types,
      loading: loading.types,
      disabled: !filters?.company_id || loading.types,
      getOptionLabel: (option) => option?.case_type || "",
      getValue: (filters, options) =>
        (options || []).find((opt) => opt?.id === filters?.case_type) || null,
      setFilter: (value) =>
        setFilters((prev) => ({ ...prev, case_type: value?.id || null })),
      handleOpen: undefined,
      handleClose: undefined,
    },

    // ---------- PROVINCIA ----------
    {
      type: "autocomplete",
      xs: 6,
      md: 1.5,
      label: "Provincia",
      options: options.provinces,
      loading: loading.provinces,
      getOptionLabel: (option) => option?.provincia || "",
      getValue: (filters, options) =>
        (options || []).find((opt) => opt?.provincia === filters?.provincia) ||
        null,
      setFilter: (value) =>
        setFilters((prev) => ({
          ...prev,
          provincia: value?.provincia || null,
        })),
      handleOpen: undefined,
      handleClose: undefined,
    },

    // ---------- ESTADO ----------
    {
      type: "autocomplete",
      xs: 12,
      md: 3,
      label: "Estado",
      options: options.case_status,
      loading: loading.case_status,
      getOptionLabel: (option) => option?.nombre_completo_status_task,
      getValue: (filters, options) =>
        (options || []).find(
          (opt) =>
            opt?.status_name === filters?.status_name &&
            String(opt?.status_key) === String(filters?.status_key),
        ) || null,
      setFilter: (value) =>
        setFilters((prev) => ({
          ...prev,
          status: value ? value.status : null,
          status_key: value ? value.status_key : null,
          status_name: value ? value.status_name : null,
          nombre_completo_status_task: value
            ? value.nombre_completo_status_task
            : null,
        })),
      handleOpen: undefined,
      handleClose: undefined,
    },

    // ---------- PERITAJE ----------
    {
      type: "autocomplete",
      xs: 6,
      md: 1.5,
      label: "Peritaje",
      options: options.peritaje,
      loading: loading.peritaje,
      getOptionLabel: (option) => option?.peritaje,
      getValue: (filters, options) =>
        (options || []).find((opt) => opt?.id === filters?.peritaje) || null,
      setFilter: (value) =>
        setFilters((prev) => ({
          ...prev,
          peritaje: value == null ? null : value.id === -1 ? null : value.id,
        })),
      handleOpen: undefined,
      handleClose: undefined,
    },

    // ---------- APUD ACTA ----------
    {
      type: "autocomplete",
      xs: 6,
      md: 1.5,
      label: "Apud Acta",
      options: options.apud_acta,
      loading: loading.apud_acta,
      getOptionLabel: (option) => option?.apud_acta,
      getValue: (filters, options) =>
        (options || []).find((opt) => opt?.id === filters?.apud_acta) || null,
      setFilter: (value) =>
        setFilters((prev) => ({
          ...prev,
          apud_acta: value == null ? null : value.id === -1 ? null : value.id,
        })),
      handleOpen: undefined,
      handleClose: undefined,
    },

    // ---------- VENCIMIENTO ----------
    {
      type: "autocomplete",
      xs: 6,
      md: 1.5,
      label: "Vencimiento",
      options: options.expiration,
      loading: loading.expiration,
      getOptionLabel: (option) => option?.expiration,
      getValue: (filters, options) =>
        (options || []).find((opt) => opt?.id === filters?.expiration) || null,
      setFilter: (value) =>
        setFilters((prev) => ({
          ...prev,
          expiration: value?.id !== -1 ? value.id : -1,
        })),
      handleOpen: undefined,
      handleClose: undefined,
    },

    // ---------- FECHAS SIMPLES ----------
    {
      type: "date",
      xs: 6,
      md: 1.5,
      label: "Fecha de entrada",
      value: dateIn,
      onChange: setDateIn,
    },
    {
      type: "date",
      xs: 6,
      md: 1.5,
      label: "Actualizado",
      value: dateUpdate,
      onChange: setDateUpdate,
    },
    {
      type: "date",
      xs: 12,
      md: 3,
      label: "Plazo de fin de tarea (Automático)",
      value: dateTask,
      onChange: setDateTask,
    },

    // ---------- RANGOS DE FECHAS ----------
    {
      type: "dateRangeEntry",
      xs: 12,
      md: 3,
    },
    {
      type: "dateRangeTrial",
      xs: 12,
      md: 3,
    },
    {
      type: "dateRangeUpdatedAt",
      xs: 12,
      md: 3,
    },
    {
      type: "dateRangeFinalTaskExpiration",
      xs: 12,
      md: 6,
    },

    {
      type: "select",
      xs: 6,
      md: 1.5,
      label: "Nº Registros",
      value: pagination?.objPerPage,
      sxGrid: {},
      options: [
        { value: 10, label: 10 },
        { value: 20, label: 20 },
        { value: 30, label: 30 },
        { value: 100, label: 100 },
        { value: 200, label: 200 },
        { value: 500, label: 500 },
        { value: 1000, label: 1000 },
        { value: 2000, label: 2000 },
      ],
      onChange: (e) => {
        const value = Number(e.target.value);
        setPagination((prev) => ({
          ...prev,
          objPerPage: value,
          pagePressed: 1,
        }));
      },
    },
  ];

  const content = (
    <div className="mainContainer">
      <div className="subMainContainer">
        {/* FILTROS */}
        {flagToShow && can("cases", "view") && (
          <Box
            component={motion.div}
            layout
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            // transition={{ duration: 0.34, ease: [0.22, 1, 0.36, 1] }}
            transition={smoothLayoutTransition}
            sx={{
              position: "relative",
              background:
                "linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(248,250,252,1) 100%)",
              border: "1px solid rgba(34, 197, 94, 0.12)",
              marginBottom: "8px",
              mx: "8px",
              borderRadius: "14px",
              boxShadow: "0 8px 20px rgba(15, 23, 42, 0.04)",
              backdropFilter: "blur(2px)",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 1,
                px: { xs: 1.2, md: 1.6 },
                py: 0.85,
                background:
                  "linear-gradient(90deg, rgba(34,197,94,0.08) 0%, rgba(255,255,255,0.96) 68%)",
                borderBottom: "1px solid rgba(34, 197, 94, 0.1)",
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  fontWeight: 700,
                  color: "#0f7a3a",
                  letterSpacing: "0.03em",
                  fontSize: "",
                }}
              >
                Filtros de búsqueda
              </Typography>

              <Button
                variant="outlined"
                size="small"
                onClick={() => setShowFilters(!showFilters)}
                endIcon={
                  showFilters ? <KeyboardArrowUp /> : <KeyboardArrowDown />
                }
                sx={{
                  minWidth: { xs: "36px", sm: "156px" },
                  width: { xs: "36px", sm: "auto" },
                  height: "30px",
                  px: { xs: 0.25, sm: 1.2 },
                  borderRadius: "8px",
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "0.78rem",
                  borderColor: "rgba(34, 197, 94, 0.24)",
                  color: "#166534",
                  backgroundColor: "rgba(255,255,255,0.88)",
                  transition:
                    "all 220ms cubic-bezier(0.22,1,0.36,1), box-shadow 220ms cubic-bezier(0.22,1,0.36,1)",
                  "& .MuiButton-endIcon": {
                    marginLeft: { xs: 0, sm: 0.5 },
                    marginRight: 0,
                  },
                  "&:hover": {
                    borderColor: "rgba(34, 197, 94, 0.42)",
                    backgroundColor: "#ffffff",
                    boxShadow: "0 4px 12px rgba(34, 197, 94, 0.14)",
                  },
                }}
              >
                <Box
                  component="span"
                  sx={{ display: { xs: "none", sm: "inline" } }}
                >
                  {showFilters ? "Ocultar filtros" : "Mostrar filtros"}
                </Box>
              </Button>
            </Box>

            <Collapse
              in={showFilters}
              timeout={{ enter: 380, exit: 280 }}
              easing={{
                enter: "cubic-bezier(0.22,1,0.36,1)",
                exit: "cubic-bezier(0.4,0,0.2,1)",
              }}
              sx={{ transformOrigin: "top center" }}
            >
              <Grid
                container
                sx={{
                  px: { xs: 0.75, md: 1.15 },
                  py: 0.95,
                  rowGap: 0.05,
                  columnGap: 0,
                  backgroundColor: "transparent",
                  justifyContent: "space-between",
                }}
              >
                {(filterFields || []).map((field, index) => {
                  const commonInputSx = {
                    width: "100%",
                    ...FILTER_INPUT_SX,
                  };

                  const paddedGridSx = {
                    p: "3px",
                    pl: `${FILTER_INPUT_LEFT_PADDING}px`,
                  };

                  if (field?.type === "text") {
                    return (
                      <Grid
                        key={index}
                        item
                        xs={field?.xs}
                        md={field?.md}
                        sx={paddedGridSx}
                      >
                        <TextField
                          fullWidth
                          label={field?.label}
                          variant="outlined"
                          size="small"
                          autoComplete="new-password"
                          value={field?.value ?? undefined}
                          onChange={field?.onChange}
                          sx={commonInputSx}
                        />
                      </Grid>
                    );
                  }

                  if (field?.type === "date") {
                    return (
                      <Grid
                        key={index}
                        item
                        xs={field?.xs}
                        md={field?.md}
                        sx={paddedGridSx}
                      >
                        <LocalizationProvider
                          dateAdapter={AdapterDayjs}
                          adapterLocale="es"
                        >
                          <DesktopDatePicker
                            label={field?.label}
                            value={field?.value}
                            onChange={field?.onChange}
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                size: "small",
                                sx: commonInputSx,
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>
                    );
                  }

                  if (field?.type === "dateRangeEntry") {
                    return (
                      <Grid
                        key={index}
                        item
                        xs={field?.xs}
                        md={field?.md}
                        sx={paddedGridSx}
                      >
                        <LocalizationProvider
                          dateAdapter={AdapterDayjs}
                          adapterLocale="es"
                        >
                          <Grid container>
                            <Grid item xs={6}>
                              <DesktopDatePicker
                                label="Entrada desde"
                                value={dateFrom}
                                onChange={setDateFrom}
                                slotProps={{
                                  textField: {
                                    fullWidth: true,
                                    size: "small",
                                    sx: {
                                      ...commonInputSx,
                                      "& fieldset": {
                                        borderRight: "none",
                                        borderTopRightRadius: "0px",
                                        borderBottomRightRadius: "0px",
                                      },
                                    },
                                  },
                                }}
                              />
                            </Grid>

                            <Grid item xs={6}>
                              <DesktopDatePicker
                                label="Entrada hasta"
                                value={dateTo}
                                onChange={setDateTo}
                                slotProps={{
                                  textField: {
                                    fullWidth: true,
                                    size: "small",
                                    sx: {
                                      ...commonInputSx,
                                      "& fieldset": {
                                        borderLeft: "none",
                                        borderTopLeftRadius: "0px",
                                        borderBottomLeftRadius: "0px",
                                      },
                                    },
                                  },
                                }}
                              />
                            </Grid>
                          </Grid>
                        </LocalizationProvider>
                      </Grid>
                    );
                  }

                  if (field?.type === "dateRangeFinalTaskExpiration") {
                    return (
                      <Grid
                        key={index}
                        item
                        xs={field?.xs}
                        md={field?.md}
                        sx={paddedGridSx}
                      >
                        <LocalizationProvider
                          dateAdapter={AdapterDayjs}
                          adapterLocale="es"
                        >
                          <Grid container>
                            <Grid item xs={6}>
                              <DesktopDatePicker
                                label="Fecha plazo fin de tarea desde"
                                value={dateDateRangeFromFinalTaskExpiration}
                                onChange={
                                  setDateDateRangeFromFinalTaskExpiration
                                }
                                slotProps={{
                                  textField: {
                                    fullWidth: true,
                                    size: "small",
                                    sx: {
                                      ...commonInputSx,
                                      "& fieldset": {
                                        borderRight: "none",
                                        borderTopRightRadius: "0px",
                                        borderBottomRightRadius: "0px",
                                      },
                                    },
                                  },
                                }}
                              />
                            </Grid>

                            <Grid item xs={6}>
                              <DesktopDatePicker
                                label="Fecha plazo fin de tarea hasta"
                                value={dateDateRangeToFinalTaskExpiration}
                                onChange={setDateDateRangeToFinalTaskExpiration}
                                slotProps={{
                                  textField: {
                                    fullWidth: true,
                                    size: "small",
                                    sx: {
                                      ...commonInputSx,
                                      "& fieldset": {
                                        borderLeft: "none",
                                        borderTopLeftRadius: "0px",
                                        borderBottomLeftRadius: "0px",
                                      },
                                    },
                                  },
                                }}
                              />
                            </Grid>
                          </Grid>
                        </LocalizationProvider>
                      </Grid>
                    );
                  }

                  if (field?.type === "dateRangeTrial") {
                    return (
                      <Grid
                        key={index}
                        item
                        xs={field?.xs}
                        md={field?.md}
                        sx={paddedGridSx}
                      >
                        <LocalizationProvider
                          dateAdapter={AdapterDayjs}
                          adapterLocale="es"
                        >
                          <Grid container>
                            <Grid item xs={6}>
                              <DesktopDatePicker
                                label="Fecha juicio desde"
                                value={dateEndFromTrial}
                                onChange={setDateEndFromTrial}
                                slotProps={{
                                  textField: {
                                    fullWidth: true,
                                    size: "small",
                                    sx: {
                                      ...commonInputSx,
                                      "& fieldset": {
                                        borderRight: "none",
                                        borderTopRightRadius: "0px",
                                        borderBottomRightRadius: "0px",
                                      },
                                    },
                                  },
                                }}
                              />
                            </Grid>

                            <Grid item xs={6}>
                              <DesktopDatePicker
                                label="Fecha juicio hasta"
                                value={dateEndToTrial}
                                onChange={setDateEndToTrial}
                                slotProps={{
                                  textField: {
                                    fullWidth: true,
                                    size: "small",
                                    sx: {
                                      ...commonInputSx,
                                      "& fieldset": {
                                        borderLeft: "none",
                                        borderTopLeftRadius: "0px",
                                        borderBottomLeftRadius: "0px",
                                      },
                                    },
                                  },
                                }}
                              />
                            </Grid>
                          </Grid>
                        </LocalizationProvider>
                      </Grid>
                    );
                  }

                  if (field?.type === "dateRangeUpdatedAt") {
                    return (
                      <Grid
                        key={index}
                        item
                        xs={field?.xs}
                        md={field?.md}
                        sx={paddedGridSx}
                      >
                        <LocalizationProvider
                          dateAdapter={AdapterDayjs}
                          adapterLocale="es"
                        >
                          <Grid container>
                            <Grid item xs={6}>
                              <DesktopDatePicker
                                label="Fecha actualizado desde"
                                value={dateEndFromUpdatedAt}
                                onChange={setDateEndFromUpdatedAt}
                                slotProps={{
                                  textField: {
                                    fullWidth: true,
                                    size: "small",
                                    sx: {
                                      ...commonInputSx,
                                      "& fieldset": {
                                        borderRight: "none",
                                        borderTopRightRadius: "0px",
                                        borderBottomRightRadius: "0px",
                                      },
                                    },
                                  },
                                }}
                              />
                            </Grid>

                            <Grid item xs={6}>
                              <DesktopDatePicker
                                label="Fecha actualizado hasta"
                                value={dateEndToUpdatedAt}
                                onChange={setDateEndToUpdatedAt}
                                slotProps={{
                                  textField: {
                                    fullWidth: true,
                                    size: "small",
                                    sx: {
                                      ...commonInputSx,
                                      "& fieldset": {
                                        borderLeft: "none",
                                        borderTopLeftRadius: "0px",
                                        borderBottomLeftRadius: "0px",
                                      },
                                    },
                                  },
                                }}
                              />
                            </Grid>
                          </Grid>
                        </LocalizationProvider>
                      </Grid>
                    );
                  }

                  if (field?.type === "autocomplete") {
                    return (
                      <Grid
                        key={index}
                        sx={paddedGridSx}
                        item
                        xs={field?.xs ?? 4}
                        md={field?.md ?? 3}
                      >
                        <Autocomplete
                          size="small"
                          sx={{
                            "& .MuiInputBase-root": {
                              minHeight: "34px",
                            },
                            "& .MuiAutocomplete-input": {
                              minWidth: "8px",
                              padding: "0 !important",
                            },
                            "& .MuiAutocomplete-popupIndicator, & .MuiAutocomplete-clearIndicator":
                              {
                                padding: "3px",
                              },
                          }}
                          value={
                            field?.getValue?.(filters, field?.options || []) ??
                            null
                          }
                          onChange={(event, value) => field?.setFilter(value)}
                          isOptionEqualToValue={(option, value) =>
                            option?.id === value?.id
                          }
                          onOpen={field?.handleOpen}
                          onClose={field?.handleClose}
                          getOptionLabel={field?.getOptionLabel}
                          options={field?.options || []}
                          loading={field?.loading}
                          loadingText="Cargando opciones..."
                          noOptionsText="Sin opciones"
                          disabled={field?.disabled}
                          clearOnEscape
                          disableClearable={false}
                          renderOption={(props, option) => (
                            <li
                              {...props}
                              key={getOptionKey(
                                option,
                                `${field.label}-option`,
                              )}
                              style={{
                                fontSize: `${FILTER_INPUT_TEXT_SIZE}px`,
                              }}
                            >
                              {field?.getOptionLabel(option)}
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={field?.label}
                              fullWidth
                              size="small"
                              sx={commonInputSx}
                              InputProps={{
                                ...params?.InputProps,
                                autoComplete: "new-password",
                                endAdornment: (
                                  <Fragment>
                                    {field?.loading && (
                                      <CircularProgress
                                        color="inherit"
                                        size={14}
                                      />
                                    )}
                                    {params?.InputProps.endAdornment}
                                  </Fragment>
                                ),
                              }}
                            />
                          )}
                        />
                      </Grid>
                    );
                  }

                  if (field?.type === "select") {
                    return (
                      <Grid
                        key={index}
                        item
                        xs={field?.xs}
                        md={field?.md}
                        sx={{
                          ...field?.sxGrid,
                          p: "4px",
                          pl: `${FILTER_INPUT_LEFT_PADDING + 3}px`,
                        }}
                      >
                        <FormControl fullWidth size="small" sx={commonInputSx}>
                          <InputLabel>{field?.label}</InputLabel>
                          <Select
                            value={field?.value}
                            label={field?.label}
                            onChange={field?.onChange}
                            sx={commonInputSx}
                            MenuProps={{
                              PaperProps: {
                                sx: {
                                  "& .MuiMenuItem-root": {
                                    fontSize: `${FILTER_INPUT_TEXT_SIZE}px`,
                                  },
                                },
                              },
                            }}
                          >
                            {(field?.options || []).map((option) => (
                              <MenuItem
                                key={option?.value}
                                value={option?.value}
                                sx={{ fontSize: `${FILTER_INPUT_TEXT_SIZE}px` }}
                              >
                                {option?.label}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    );
                  }

                  return null;
                })}

                {/* BOTONES */}

                <Grid
                  item
                  xs={12}
                  md={12}
                  textAlign="center"
                  sx={{
                    display: "inline-flex",
                    flexWrap: "wrap",
                    gap: "6px",
                    justifyContent: "center",
                    mt: 0.55,
                    pt: 0.9,
                    borderTop: "1px solid rgba(28, 48, 74, 0.12)",
                  }}
                >
                  <CustomButtonPlusIcon
                    icon={Search}
                    text={"BUSCAR"}
                    handleFunction={() => setSearch(!search)}
                    position={"start"}
                    variant={"outlined"}
                    color={"info"}
                  />
                  <CustomButtonPlusIcon
                    icon={CleaningServices}
                    text={"LIMPIAR FILTROS"}
                    handleFunction={handleFilterStates}
                    position={"start"}
                    variant={"outlined"}
                    color={"error"}
                  />
                </Grid>
              </Grid>
            </Collapse>
          </Box>
        )}

        {flag && hasPermission && (
          <LoadingPage isLoading={flag} heightProp={"70vh"} />
        )}

        {/* TABLA */}
        {!flag && can("cases", "view") && (
          <Fade timeout={600} in={data?.cases?.length > 0 || dataNoResults}>
            <div>
              <Table
                icon={CreateNewFolder}
                columns={columns}
                data={data?.cases || []}
                view={"expediente"}
                viewTitle={"expedientes"}
                totalPagesNumber={data?.totalPagesNumber}
                flagToShow={flagToShow}
                viewPermission={"cases"}
                // pagination
                onPageChange={handlePageClick}
                pageCount={data?.pageCount}
                forcePage={pagination?.pagePressed - 1}
                // SORT
                onSort={handleSort}
                sortColumn={sortColumn}
                sortDirection={sortDirection}
                objectPerPage={pagination?.objPerPage}
                //FLAGs
                flagNoCreate={caseFlagFromClient}
              />
            </div>
          </Fade>
        )}
      </div>
    </div>
  );

  // ---------- RENDERIZADO ----------
  return (
    <div className="fatherContainer">
      {flagToShow && <CommonSubHeader title="Expedientes" />}
      {!hasPermission && <Unauthorized />}
      {hasPermission && content}
    </div>
  );
};

export default Expedientes;
